import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IContact } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/contacts';
const $urlReply = '/admin/contacts/actions/reply';

interface ISearchRequest {
  offset: number;
  limit: number;
  keyword: string;
  dateFrom: string;
  dateTo: string;
}

interface ISearchResult {
  items: IContact[];
  count: number;
}

interface IDeleteRequest {
  contactId: number;
}

interface IReplyRequest {
  contactId: number;
  memo: string;
}

export default {
  getContacts(req: ISearchRequest, success: (res: ISearchResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<ISearchResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  reply(req: IReplyRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlReply, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
